/**
 * 青山科技页面
 */
import React from 'react';
import './regulation.scss';
import Rule from './rule';
import AwardHeader from '../../../components/AwardHeader/AwardHeader';

const Regulation = () => {
  return (
    <div className="award-regulation">
      <AwardHeader />
      <div className="about-award block-container marker" style={{ marginTop: 150 }}>
        <span className="title">青山科技奖章程</span>
        <div className="regulation">
          <Rule />
        </div>
      </div>
    </div>
  );
};

export default Regulation;
